import { useQuery } from '@tanstack/react-query';

import { getSuggestedApprovers } from '../api/time-offs.api';
import { SUGGESTED_APPROVERS_QUERY_KEY } from '../constants/time-offs-query-keys';

// Cache so removing a prefilled approver (which re-enables the query) doesn't
// refetch and re-add it. Assignment/project/team mutations invalidate it.
const SUGGESTED_APPROVERS_STALE_TIME = 60 * 1000; // 1 minute

/** Suggested approvers to prefill the create-mode approvers table. */
export const useSuggestedApprovers = (enabled = true) =>
  useQuery({
    queryKey: SUGGESTED_APPROVERS_QUERY_KEY,
    queryFn: getSuggestedApprovers,
    enabled,
    staleTime: SUGGESTED_APPROVERS_STALE_TIME,
  });
